import "./PartnerPricing.module.css";
import Header from "@/reusable_sections/Header";
import PartnerHero from "./sections/PartnerHero";
import PricingTrungTam from "./sections/PricingTrungTam";
import SchoolPricing from "./sections/SchoolPricing";
import PartnershipModelComparison from "./sections/PartnershipModelComparison";
import EquipmentPricing from "./sections/EquipmentPricing";
import ContactCTA from "./sections/ContactCTA";
import Footer from "@/reusable_sections/Footer";
export default function PartnerPricingPage() {
  return <div>
      <Header />
      <PartnerHero />
      <PricingTrungTam />
      <SchoolPricing />
      <PartnershipModelComparison />
      <EquipmentPricing />
      <ContactCTA />
      <Footer />
    </div>;
}